import { instance, errorService, savePreviousData } from '@/services/api'
import { projectAPIs, dropdownAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import {
  calculatePerimeter,
  calculateAreaBuildingFootprint,
  calculateBuildingGeneralHeight,
  showNotification,
} from '@/services/calculate'
import {
  socketEvents,
  checkEvents,
  checkFiles,
  formatKeys,
  validateNumber,
  tableName,
} from '@/services/config'
import { updateGridRecord } from '@/services/grid'
import { formatValue, formatCurrency } from '@/services/convert'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import InputEditor from '@/components/DynamicComponents/Renderers/inputEditor'
import SelectEditorDynamic from '@/components/DynamicComponents/Renderers/selectEditorDynamic'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import exportTemplates from '@/components/DynamicComponents/Projects/Export'
import importTemplates from '@/components/DynamicComponents/Projects/Import'
import bankModal from '@/components/DynamicComponents/Projects/BankModal'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import NumberRender from '@/components/DynamicComponents/Renderers/numberRenderer'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'

export default {
  props: [
    'componentProjectKey',
    'projectData',
    'screenIndentifier',
    'dropdownData',
    'tableId',
    'projectModule',
    'collapsed',
    'child',
    'columnSettings',
  ],
  components: {
    'ag-grid-vue': AgGridVue,
    exportTemplates,
    importTemplates,
    bankModal,
  },
  data() {
    return {
      savePreviousData: savePreviousData,
      tableLoader: false,
      fieldLoader: false,
      fieldName: null,
      dataSourceInterior: [],
      loading: true,
      selected: false,
      formGeneral: {
        id: undefined,
        conditionFactorId: undefined,
        constructionQualityFactorId: undefined,
        softCosts: undefined,
        areaTotalBuilding: undefined,
        numberOfStories: undefined,
        areaBuildingFootprint: undefined,
        perimeterBuildingFootprint: undefined,
        averageStoryHeight: undefined,
        totalSiteArea: undefined,
        numberOfBuilding: 1,
        constructionQualityFactor: undefined,
        conditionFactor: undefined,
      },
      formDepreciation: {
        id: undefined,
        clientAssetNumber: undefined,
        costBasis: undefined,
        method: undefined,
        convention: undefined,
        life: undefined,
        bonusPercentage: undefined,
        accumulatedDepreciationFederal: undefined,
        accumulatedDepreciationState: undefined,
        federalAMT: undefined,
        stateAMT: undefined,
      },
      formTenants: {
        id: undefined,
        tenantApproachId: null,
        tenantApproach: undefined,
        tenantId: undefined,
        tenantBank: undefined,
        tenantBankId: undefined,
        tenantType: undefined,
        tenantTypeId: undefined,
        tenantSF: undefined,
        isLocked: false,
        takeoffCount: 0,
        tenants: [],
      },
      rulesformGeneral: {
        constructionQualityFactorId: [
          {
            required: true,
            message: 'Please select construction quality factor',
            trigger: 'change',
          },
        ],
        conditionFactorId: [
          {
            required: true,
            message: 'Please select condition factor',
            trigger: 'change',
          },
        ],
        softCosts: [
          {
            required: true,
            message: 'Please enter soft costs (%)',
            trigger: 'blur',
          },
        ],
        areaTotalBuilding: [
          {
            required: true,
            message: 'Please enter area of total building',
            trigger: 'blur',
          },
        ],
        numberOfStories: [
          {
            required: true,
            message: 'Please enter number of stories',
            trigger: 'blur',
          },
        ],
        areaBuildingFootprint: [
          {
            required: true,
            message: 'Please enter area building foot print',
            trigger: 'blur',
          },
        ],
        perimeterBuildingFootprint: [
          {
            required: true,
            message: 'Please enter perimeter building footprint',
            trigger: 'blur',
          },
        ],
        averageStoryHeight: [
          {
            required: true,
            message: 'Please enter story height',
            trigger: 'blur',
          },
        ],
        totalSiteArea: [
          {
            required: true,
            message: 'Please enter total site area',
            trigger: 'blur',
          },
        ],
        numberOfBuilding: [
          {
            required: true,
            message: 'Please enter number of buildings',
            trigger: 'blur',
          },
        ],
      },
      rulesformDepreciation: {
        clientAssetNumber: [
          {
            required: true,
            trigger: 'blur',
          },
        ],
        costBasis: [
          {
            required: true,
            trigger: 'blur',
          },
        ],
        method: [
          {
            required: true,
            message: 'Please select method',
            trigger: 'change',
          },
        ],
        convention: [
          {
            required: true,
            message: 'Please select convention',
            trigger: 'change',
          },
        ],
        life: [
          {
            required: true,
            message: 'Please select tax life',
            trigger: 'change',
          },
        ],
        bonusPercentage: [
          {
            required: true,
            message: 'Please enter bonus percentage',
            trigger: 'blur',
          },
        ],
        accumulatedDepreciationFederal: [
          {
            required: true,
            message: 'Please enter Accumulated Depreciation Federal',
            trigger: 'blur',
          },
        ],
        accumulatedDepreciationState: [
          {
            message: 'Please enter Accumulated Depreciation State',
            trigger: 'blur',
          },
        ],
        federalAMT: [
          {
            message: 'Please enter Federal AMT',
            trigger: 'blur',
          },
        ],
        stateAMT: [
          {
            message: 'Please enter State AMT',
            trigger: 'blur',
          },
        ],
      },

      rulesformTenants: {
        tenantApproachId: null,
      },
      loader: true,
      data: [],
      title: '',
      newTenants: null,
      selectedRowKeys: [],
      headStyle: {
        'font-weight': 'bold',
        background: '#333333 !important',
        color: '#ffffff !important',
        padding: '0 10px',
      },
      loadTenant: false,
      tenantLoader: true,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        suppressContextMenu: true,
        rowDragManaged: true,
        suppressScrollOnNewData: true,
        defaultColDef: {
          sortable: true,
          resizable: true,
          suppressMovable: true,
          singleClickEdit: true,
          menuTabs: ['filterMenuTab'],
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      tableParams: null,
      tenantHeight: {
        width: '100%',
        height: '24.2em',
      },
      exportClicked: false,
      uploadedFile: null,
      importClicked: false,
      importColDef: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Suite #',
          field: 'suite',
          width: 80,
        },
        {
          headerName: 'Tenant Name',
          field: 'tenantName',
          width: 120,
        },
        {
          headerName: 'Tenant Type',
          field: 'tenantType',
          width: 120,
          hide: this.projectData.analysisTypeId === 2,
        },
        {
          headerName: 'Tenant SF',
          field: 'tenantSF',
          width: 120,
        },
      ],
      loadImport: false,
      bankName: null,
      bankId: null,
      visible: false,
      cardHeight: '17em',
      apiURL: null,
      showBank: false,
      tenantBanks: this.dropdownData.tenantBank,
      message: undefined,
      tenantDetails: null,
      sidebarView: false,
      selectedTenantApproachId: null,
      modal: undefined,
      postSort: null,
      sortData: null,
      tenantId: undefined,
      componentKey: this.componentProjectKey,
      isArchive: false,
      depreciationDDList: [],
      methods: [],
      conventions: [],
      life: [],
      buldingGeneralData: null,
      formatCurrency: formatCurrency,
      is481Included: true,
      currencyFields: [
        'accumulatedDepreciationFederal',
        'accumulatedDepreciationState',
        'federalAMT',
        'stateAMT',
        'costBasis',
      ],
      maxLength: 13,
    }
  },
  beforeMount() {
    this.isArchive = _.get(this.projectData, 'isArchive', false)
    this.loadingConfig()
  },
  created() {
    this.$socketHub.$on('message-received', this.recievedMessage)
  },
  mounted() {
    this.getBuildingGeneral()
    this.$root.$off(`cloneTenant${this.projectData.assetId}`)
    this.$root.$on(`cloneTenant${this.projectData.assetId}`, this.cloneTenant)
    this.$root.$off(`saveTenantData${this.projectData.assetId}`)
    this.$root.$on(
      `saveTenantData${this.projectData.assetId}`,
      this.updateTenant,
    )
    this.$root.$off(`deleteTenant${this.projectData.assetId}`)
    this.$root.$on(
      `deleteTenant${this.projectData.assetId}`,
      this.deleteTenant,
    )
    this.$root.$off(`copyTenantBank${this.projectData.assetId}`)
    this.$root.$on(
      `copyTenantBank${this.projectData.assetId}`,
      this.updateTenantBank,
    )
    this.$root.$off(`addInBank${this.projectData.assetId}`)
    this.$root.$on(`addInBank${this.projectData.assetId}`, this.saveAsBank)
    window.removeEventListener('resize', this.getWindowSize)
    window.addEventListener('resize', this.getWindowSize)
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
  },
  beforeDestroy() {
    this.$root.$off(`deleteTenant${this.projectData.assetId}`)
    this.$root.$off(`saveTenantData${this.projectData.assetId}`)
    this.$root.$off(`copyTenantBank${this.projectData.assetId}`)
    this.$root.$off(`addInBank${this.projectData.assetId}`)
    this.$root.$off(`cloneTenant${this.projectData.assetId}`)
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
  },
  watch: {
    collapsed() {
      this.sidebarView = this.collapsed
    },
  },
  methods: {
    // Grid Column Section Start //
    loadingConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        inputCellEditor: InputEditor,
        selectEditor: SelectEditorDynamic,
        inputNumberEditor: InputNumberEditor,
        customFilter: CustomFilter,
        numberRender: NumberRender,
        toolTipRenderer: ToolTipRenderer,
      }
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 36,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
          hide: this.isArchive,
        },
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          resizable: false,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'Suite #',
          field: 'suite',
          width: 80,
          headerTooltip: 'Suite',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellEditor: 'inputCellEditor',
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'projectTenants',
            dataType: 'string',
          },
          editable: !this.isArchive,
        },
        {
          headerName: 'Tenant Name',
          field: 'tenantName',
          headerTooltip: 'Tenant Name',
          cellEditor: 'inputCellEditor',
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'projectTenants',
            dataType: 'string',
          },
          editable: !this.isArchive,
        },
        {
          headerName: 'Tenant Type',
          field: 'tenantType',
          width: 200,
          headerTooltip: 'Tenant Type',
          cellEditor: 'selectEditor',
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'projectTenantType',
            dataType: 'string',
            dropdownName: 'tenantType',
            dropdownData: this.dropdownData,
          },
          suppressSizeToFit: true,
          editable: !this.isArchive,
          hide: this.projectData.analysisTypeId === 2,
        },
        {
          headerName: 'Tenant SF',
          field: 'tenantSF',
          width: 120,
          headerTooltip: 'Tenant SF',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellEditor: 'inputNumberEditor',
          filter: 'customFilter',
          cellRendererParams: {
            type: 'projectTenants',
            dataType: 'int',
            placeholder: 'Tenant SF',
            precision: 0,
            min: 0,
            fixed: 0,
            max: 999999,
          },
          cellRenderer: 'numberRender',
          suppressSizeToFit: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Tenant Bank',
          field: 'tenantBank',
          width: 200,
          headerTooltip: 'Tenant Bank',
          filter: 'customFilter',
          cellEditor: 'selectEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'projectTenantBank',
            dropdownName: 'tenantBank',
            dropdownData: this.dropdownData,
          },
          suppressSizeToFit: true,
          editable: params => {
            return this.formTenants.tenantApproachId === 1 && !this.isArchive
          },
          hide: this.projectData.analysisTypeId === 2,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          headerClass: 'header-center',
          width: 100,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          cellRendererParams: {
            type: 'tenants',
            asset: this.projectData,
            formTenants: this.formTenants,
            isTenantClone: true,
            formGeneral: this.formGeneral,
            analysisTypeId: this.projectData.analysisTypeId,
            screenType: 'BuildingGeneral',
          },
          pinned: 'right',
          menuTabs: [],
          hide: this.isArchive,
        },
      ]
    },
    // Grid Column Section End //

    preventInvalidChars(e) {
      const invalidChars = ['e', 'E', '+', '-']
      if (invalidChars.includes(e.key)) {
        e.preventDefault()
      }
    },

    handlePaste(e) {
      const pasted = (e.clipboardData || window.clipboardData).getData('text')
      if (!/^\d*\.?\d*$/.test(pasted)) {
        e.preventDefault()
      }
    },

    formatCurrencyInput(value, field) {
      const num = parseFloat(value)
      this.formDepreciation[field] = formatCurrency(num)
      this.updateBuildingGeneral(field, value)
    },

    onCurrencyFocus(field, event) {
      const rawValue = event.target.value.replace(/[$,]/g, '')
      const parsedValue = parseFloat(rawValue)

      // If it's a valid number, store it. Else keep it empty.
      this.formDepreciation[field] = isNaN(parsedValue) ? '' : parsedValue
    },

    onInputChange(field, event) {
      let value = event.target.value

      // Allow only numbers and a single dot
      value = value.replace(/[^\d.]/g, '')

      // Prevent multiple dots
      const parts = value.split('.')
      if (parts.length > 2) {
        value = parts[0] + '.' + parts[1] // Keep only first dot
      }

      // Optional: remove leading zeros
      // if (value.startsWith('00')) {
      //   value = value.replace(/^0+/, '0')
      // } else if (value.startsWith('0') && value[1] !== '.') {
      //   value = value.replace(/^0+/, '')
      // }

      this.formDepreciation[field] = value
    },

    // Get depreciation method,convention,tax life DD
    getDepreciationValues() {
      instance
        .get(dropdownAPIs.depreciationsValues)
        .then(response => {
          this.depreciationDDList = _.get(response.data, 'result', [])
          this.methods = [
            ...new Set(this.depreciationDDList.map(item => item.method)),
          ]
          this.conventions = [
            ...new Set(
              this.depreciationDDList
                .filter(item => item.method === this.buldingGeneralData.method)
                .map(item => item.convention),
            ),
          ]
          this.life = [
            ...new Set(
              this.depreciationDDList
                .filter(
                  item => item.convention === this.buldingGeneralData.convention,
                )
                .map(item => item.life),
            ),
          ].sort((a, b) => a - b)
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Building General Details Section Start //
    getBuildingGeneral() {
      instance
        .get(
          projectAPIs.project.asset.buildingGeneral.details(
            this.$route.params.id,
            this.projectData.assetId,
          ),
        )
        .then(response => {
          this.cardHeight = calculateBuildingGeneralHeight(
            'projectBuildingGeneral',
            this.projectData.structureProfileId === 3,
          )
          this.buldingGeneralData = _.get(response.data, 'result', null)
          this.is481Included = this.buldingGeneralData.needsOriginalDepreciation
          this.getDepreciationValues()
          this.formGeneral = formatKeys(
            _.get(response.data, 'result', null),
            this.formGeneral,
          )

          this.formDepreciation = formatKeys(
            _.get(response.data, 'result', null),
            this.formDepreciation,
          )
          this.currencyFields.forEach(key => {
            if (this.formDepreciation[key] != null) {
              this.formDepreciation[key] = formatCurrency(
                this.formDepreciation[key],
              )
            }
          })

          this.loader = false
          this.sidebarView = this.collapsed
          if (this.projectData.structureProfileId === 3) {
            this.getColumnSettings(this.gridOptions)
            this.getTenants(this.tableParams)
          } else {
            if (this.formGeneral.assetId === this.projectData.assetId) {
              this.$root.$off(`deleteTenant${this.projectData.assetId}`)
            }
          }
          Object.assign(this.projectData, {
            area_Total_Building: this.formGeneral.areaTotalBuilding,
            area_Building_Footprint: this.formGeneral.areaBuildingFootprint,
            number_Of_Stories: this.formGeneral.numberOfStories,
            perimeter_Building_Footprint: this.formGeneral
              .perimeterBuildingFootprint,
            average_Story_Height: this.formGeneral.averageStoryHeight,
            totalSiteArea: this.formGeneral.totalSiteArea,
          })
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    updateBuildingGeneral(fieldName, value) {
      this.fieldName = fieldName
      const currentValue = value == null ? '' : value
      const previousValue =
        window.previousValue == null
          ? ''
          : window.previousValue.toString().replace(/[$,]/g, '')
      let request = {}
      if (previousValue.toString() !== currentValue.toString()) {
        let isValid = true
        const msg = 'Please wait while updating building general details'
        this.$root.$emit('popupUpdation', true, true, msg)
        switch (fieldName) {
          case 'softCosts':
            isValid = validateNumber(
              this.formGeneral.softCosts,
              fieldName,
              'Soft Costs (%)',
            )
            if (isValid) {
              this.formGeneral.softCosts = value
                ? formatValue(value, 2)
                : value
              request = {
                softCosts: value ? formatValue(value, 2) : null,
              }
            } else {
              this.formGeneral.softCosts = previousValue
            }
            break
          case 'areaTotalBuilding':
            isValid = validateNumber(
              this.formGeneral.areaTotalBuilding,
              fieldName,
              'Area (Total Building)',
            )
            if (isValid) {
              this.formGeneral.areaTotalBuilding = value
                ? formatValue(value, 0)
                : value
              this.formGeneral.areaBuildingFootprint = calculateAreaBuildingFootprint(
                value ? formatValue(value, 0) : value,
                this.formGeneral.numberOfStories,
              )
              this.formGeneral.perimeterBuildingFootprint = calculatePerimeter(
                this.formGeneral.numberOfBuilding || 1,
                this.formGeneral.areaBuildingFootprint || 0,
              )
              request = {
                areaTotalBuilding: value ? formatValue(value, 0) : null,
                areaBuildingFootprint: this.formGeneral.areaBuildingFootprint,
                perimeterBuildingFootprint: this.formGeneral
                  .perimeterBuildingFootprint,
              }
            } else {
              this.formGeneral.areaTotalBuilding = previousValue
            }
            break
          case 'numberOfStories':
            isValid = validateNumber(
              this.formGeneral.numberOfStories,
              fieldName,
              'Number of Stories',
            )
            if (isValid) {
              this.formGeneral.numberOfStories = value
                ? formatValue(value, 0)
                : value
              this.formGeneral.areaBuildingFootprint = calculateAreaBuildingFootprint(
                this.formGeneral.areaTotalBuilding,
                value ? formatValue(value, 0) : value,
              )
              this.formGeneral.perimeterBuildingFootprint = calculatePerimeter(
                this.formGeneral.numberOfBuilding || 1,
                this.formGeneral.areaBuildingFootprint || 0,
              )
              request = {
                numberOfStories: value ? formatValue(value, 0) : null,
                areaBuildingFootprint: this.formGeneral.areaBuildingFootprint,
                perimeterBuildingFootprint: this.formGeneral
                  .perimeterBuildingFootprint,
              }
            } else {
              this.formGeneral.numberOfStories = previousValue
            }
            break
          case 'areaBuildingFootprint':
            isValid = validateNumber(
              this.formGeneral.areaBuildingFootprint,
              fieldName,
              'Area (Building Footprint)',
            )
            if (isValid) {
              this.formGeneral.areaBuildingFootprint = value
                ? formatValue(value, 0)
                : value
              this.formGeneral.perimeterBuildingFootprint = calculatePerimeter(
                this.formGeneral.numberOfBuilding || 1,
                value ? formatValue(value, 0) : 0,
              )
              request = {
                areaBuildingFootprint: value ? formatValue(value, 0) : null,
                perimeterBuildingFootprint: this.formGeneral
                  .perimeterBuildingFootprint,
              }
            } else {
              this.formGeneral.areaBuildingFootprint = previousValue
            }
            break
          case 'perimeterBuildingFootprint':
            isValid = validateNumber(
              this.formGeneral.perimeterBuildingFootprint,
              fieldName,
              'Perimeter (Building Footprint)',
            )
            if (isValid) {
              this.formGeneral.perimeterBuildingFootprint = value
                ? formatValue(value, 0)
                : value
              request = {
                perimeterBuildingFootprint: value ? formatValue(value, 0) : null,
              }
            } else {
              this.formGeneral.perimeterBuildingFootprint = previousValue
            }
            break
          case 'averageStoryHeight':
            isValid = validateNumber(
              this.formGeneral.averageStoryHeight,
              fieldName,
              'Average Story Height',
            )
            if (isValid) {
              this.formGeneral.averageStoryHeight = value
                ? formatValue(value, 0)
                : value
              request = {
                averageStoryHeight: value ? formatValue(value, 0) : null,
              }
            } else {
              this.formGeneral.averageStoryHeight = previousValue
            }
            break
          case 'constructionQualityFactorId':
            const constructionfactor = this.dropdownData.construction_quality_factor.find(
              i => i.id === value,
            )
            request = {
              constructionQualityFactorId: value,
              constructionQualityFactor: constructionfactor
                ? constructionfactor.option
                : null,
              ConstructionQualityFactorValue: constructionfactor
                ? constructionfactor.value
                : null,
            }
            break
          case 'conditionFactorId':
            const factor = this.dropdownData.condition_factor.find(
              i => i.id === value,
            )
            request = {
              conditionFactorId: value,
              ConditionFactor: factor ? factor.option : null,
              ConditionFactorValue: factor ? factor.value : null,
            }
            break
          case 'totalSiteArea':
            isValid = validateNumber(
              this.formGeneral.totalSiteArea,
              fieldName,
              'Total Site Area',
            )
            if (isValid) {
              this.formGeneral.totalSiteArea = value
                ? formatValue(value, 0)
                : value
              request = {
                totalSiteArea: value ? formatValue(value, 0) : null,
              }
            } else {
              this.formGeneral.totalSiteArea = previousValue
            }
            break
          case 'numberOfBuilding':
            isValid = validateNumber(
              this.formGeneral.numberOfBuilding,
              fieldName,
              'Number of Building',
            )
            if (isValid) {
              this.formGeneral.numberOfBuilding =
                value === '0' ? 1 : value ? formatValue(value, 0) : 1
              this.formGeneral.perimeterBuildingFootprint = calculatePerimeter(
                value === '0' ? 1 : value ? formatValue(value, 0) : 1,
                this.formGeneral.areaBuildingFootprint || 0,
              )
              request = {
                numberOfBuilding:
                  value === '0' ? 1 : value ? formatValue(value, 0) : 1,
                perimeterBuildingFootprint: this.formGeneral
                  .perimeterBuildingFootprint,
              }
            } else {
              this.formGeneral.numberOfBuilding = previousValue
            }
            break
          case 'method':
            this.conventions = [
              ...new Set(
                this.depreciationDDList
                  .filter(item => item.method === value)
                  .map(item => item.convention),
              ),
            ]
            this.life = [
              ...new Set(
                this.depreciationDDList
                  .filter(item => item.convention === this.conventions[0])
                  .map(item => item.life),
              ),
            ].sort((a, b) => a - b)
            this.formDepreciation.convention = this.conventions[0]
            this.formDepreciation.life = this.life[0]

            request = {
              method: value,
              convention: this.conventions[0],
              life: this.life[0],
            }
            break
          case 'convention':
            this.life = [
              ...new Set(
                this.depreciationDDList
                  .filter(item => item.convention === value)
                  .map(item => item.life),
              ),
            ].sort((a, b) => a - b)
            this.formDepreciation.life = this.life[0]
            request = {
              convention: value,
              life: this.formDepreciation.life,
            }
            break
          case 'life':
            request = {
              life: value,
            }
            break
          case 'bonusPercentage':
            isValid = validateNumber(
              this.formDepreciation.bonusPercentage,
              fieldName,
              'Bonus Percentage',
            )
            if (isValid) {
              this.formDepreciation.bonusPercentage = value
                ? formatValue(value, 2)
                : value
              request = {
                bonusPercentage: value ? formatValue(value, 2) : null,
              }
            } else {
              this.formDepreciation.bonusPercentage = previousValue
            }
            break
          case 'accumulatedDepreciationFederal':
            isValid = validateNumber(
              this.formDepreciation.accumulatedDepreciationFederal,
              fieldName,
              'Accumulated Depreciation - Fed',
            )
            if (isValid) {
              this.formDepreciation.accumulatedDepreciationFederal = value
                ? formatCurrency(value.slice(0, this.maxLength))
                : value
              request = {
                accumulatedDepreciationFederal: value
                  ? value
                    .slice(0, this.maxLength)
                    .toString()
                    .replace(/[$,]/g, '')
                  : null,
              }
            } else {
              this.formDepreciation.accumulatedDepreciationFederal = previousValue
            }
            break
          case 'accumulatedDepreciationState':
            isValid = validateNumber(
              this.formDepreciation.accumulatedDepreciationState,
              fieldName,
              'Accumulated Depreciation - State',
            )
            if (isValid) {
              this.formDepreciation.accumulatedDepreciationState = value
                ? formatCurrency(value.slice(0, this.maxLength))
                : value
              request = {
                accumulatedDepreciationState: value
                  ? value
                    .slice(0, this.maxLength)
                    .toString()
                    .replace(/[$,]/g, '')
                  : null,
              }
            } else {
              this.formDepreciation.accumulatedDepreciationState = previousValue
            }
            break
          case 'federalAMT':
            isValid = validateNumber(
              this.formDepreciation.federalAMT,
              fieldName,
              'Federal AMT',
            )
            if (isValid) {
              this.formDepreciation.federalAMT = value
                ? formatCurrency(value.slice(0, this.maxLength))
                : value
              request = {
                federalAMT: value
                  ? value
                    .slice(0, this.maxLength)
                    .toString()
                    .replace(/[$,]/g, '')
                  : null,
              }
            } else {
              this.formDepreciation.federalAMT = previousValue
            }
            break
          case 'stateAMT':
            isValid = validateNumber(
              this.formDepreciation.stateAMT,
              fieldName,
              'State AMT',
            )
            if (isValid) {
              this.formDepreciation.stateAMT = value
                ? formatCurrency(value.slice(0, this.maxLength))
                : value
              request = {
                stateAMT: value
                  ? value
                    .slice(0, this.maxLength)
                    .toString()
                    .replace(/[$,]/g, '')
                  : null,
              }
            } else {
              this.formDepreciation.stateAMT = previousValue
            }
            break

          case 'needsOriginalDepreciation':
            this.is481Included = value
            request = {
              needsOriginalDepreciation: value,
            }
            break
          case 'clientAssetNumber':
            isValid = validateNumber(
              formatValue(+this.formDepreciation.clientAssetNumber, 0),
              fieldName,
              'Client Asset Number',
            )
            if (isValid) {
              this.formDepreciation.clientAssetNumber = formatValue(+value, 0)
              request = {
                clientAssetNumber: formatValue(+value, 0),
              }
            } else {
              this.formDepreciation.clientAssetNumber = previousValue
            }
            break

          default:
            break
        }
        if (isValid) {
          this.fieldLoader = true
          instance
            .patch(
              projectAPIs.project.asset.buildingGeneral.update(
                this.$route.params.id,
                this.projectData.assetId,
                this.formGeneral.id,
              ),
              request,
            )
            .then(response => {
              this.fieldName = undefined
              this.fieldLoader = false
            })
            .catch(err => {
              errorService(err)
              this.fieldLoader = false
              this.$root.$emit('popupUpdation', false, true, null)
            })
        } else {
          this.$root.$emit('popupUpdation', false, true, null)
        }
      }
    },
    // Building General Details Section End //

    // Tenant Details Section Start //
    getTenants(params) {
      if (this.formGeneral.id) {
        let url = projectAPIs.project.asset.buildingGeneral.tenant.list(
          this.$route.params.id,
          this.projectData.assetId,
          this.formGeneral.id,
        )
        if (this.projectData.analysisTypeId === 2) {
          url = projectAPIs.project.asset.newConstbuildingGeneral.tenant.list(
            this.$route.params.id,
            this.projectData.assetId,
            this.formGeneral.id,
          )
        }
        this.tenantLoader = true
        instance
          .get(url)
          .then(response => {
            this.formTenants.tenants = []
            if (this.projectData.analysisTypeId === 1) {
              this.formTenants = _.get(response.data, 'result', null)
              this.showBank =
                this.formTenants.tenantApproachId === 2 &&
                this.projectData.analysisTypeId === 1
              const tenant = _.get(response.data, 'result.tenants', []).find(
                i => i.type === 2,
              )
              if (tenant) {
                this.formTenants.tenantId = tenant.id
                this.formTenants.tenantBank = tenant.tenantBank
                this.formTenants.tenantBankId = tenant.tenantBankId
                this.formTenants.tenantType = tenant.tenantType
                this.formTenants.tenantTypeId = tenant.tenantTypeId
                this.formTenants.tenantSF = tenant.tenantSF
                this.formTenants.takeoffCount = _.get(
                  tenant,
                  'takeoffCount',
                  0,
                )
                if (this.formTenants.tenantTypeId) {
                  this.tenantBanks = this.dropdownData.tenantBank.filter(
                    i => i.tenantTypeId === this.formTenants.tenantTypeId,
                  )
                }
              }
              this.formTenants.tenants = _.get(
                this.formTenants,
                'tenants',
                [],
              ).filter(i => i.type === 1)
              this.formTenants.tenants.forEach(element => {
                element.tenantApproachId = this.formTenants.tenantApproachId
              })
              if (
                this.gridOptions &&
                this.gridOptions.api &&
                this.gridOptions.columnApi
              ) {
                this.gridOptions.api.redrawRows()
                this.gridOptions.columnApi.applyColumnState({
                  state: [
                    {
                      colId: 'tenantBank',
                      hide: this.formTenants.tenantApproachId === 2,
                    },
                    {
                      colId: 'tenantType',
                      hide: this.formTenants.tenantApproachId === 2,
                    },
                  ],
                })
              }
            } else {
              if (this.gridOptions && this.gridOptions.columnApi) {
                this.gridOptions.columnApi.applyColumnState({
                  state: [
                    {
                      colId: 'tenantBank',
                      hide: true,
                    },
                    {
                      colId: 'tenantType',
                      hide: true,
                    },
                  ],
                })
              }
              this.formTenants.tenants = _.get(response.data, 'result', [])
            }
            if (this.sortData) {
              this.formTenants.tenants = _.orderBy(
                this.formTenants.tenants,
                [this.sortData.colId],
                [this.sortData.sort],
              )
            }
            this.tenantLoader = false
          })
          .catch(error => {
            this.tenantLoader = false
            errorService(error)
          })
      }
    },

    addTenant() {
      this.tableLoader = true
      let url = projectAPIs.project.asset.buildingGeneral.tenant.add(
        this.$route.params.id,
        this.projectData.assetId,
        this.formGeneral.id,
      )
      if (this.projectData.analysisTypeId === 2) {
        url = projectAPIs.project.asset.newConstbuildingGeneral.tenant.add(
          this.$route.params.id,
          this.projectData.assetId,
          this.formGeneral.id,
        )
      }
      instance
        .post(url, {
          tenantApproachId: this.formTenants.tenantApproachId,
          tenantCount: this.newTenants ? this.newTenants : 1,
        })
        .then(response => {
          this.getTenants()
          this.newTenants = null
          this.tableLoader = false
        })
        .catch(err => {
          this.tableLoader = false
          errorService(err)
        })
    },

    deleteAllTenants() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected tenants ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              tenants
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() {},
        class: 'test',
      })
    },

    deleteTenant(record) {
      if (record.assetId === this.projectData.assetId) {
        var that = this
        this.$confirm({
          title: `Are you sure want to delete ${record.suite} ?`,
          content: h => (
            <div style="color:red">
              <p>
                This action will delete all information related to this tenant.
              </p>
              <p>Please confirm.</p>
            </div>
          ),
          onOk() {
            that.confirmDelete(record)
          },
          onCancel() {},
        })
      }
    },

    confirmDelete(record) {
      this.loading = true
      this.tenantLoader = true
      const req = record ? [record.id] : this.selectedRowKeys
      let url = projectAPIs.project.asset.buildingGeneral.tenant.delete(
        this.$route.params.id,
        this.projectData.assetId,
        this.formGeneral.id,
      )
      if (this.projectData.analysisTypeId === 2) {
        url = projectAPIs.project.asset.newConstbuildingGeneral.tenant.delete(
          this.$route.params.id,
          this.projectData.assetId,
          this.formGeneral.id,
        )
      }
      instance
        .delete(url, {
          data: req,
        })
        .then(response => {
          this.loading = true
          this.getTenants()
          this.selectedRowKeys = record
            ? this.selectedRowKeys.remove(record.id)
            : []
        })
        .catch(err => {
          this.loading = false
          this.tenantLoader = false
          errorService(err)
        })
    },

    updateTenantApproach(FieldName, value) {
      this.fieldName = FieldName
      const currentValue = !value ? '' : value
      const previousValue = !window.previousValue ? '' : window.previousValue
      if (previousValue.toString() !== currentValue.toString()) {
        this.fieldLoader = true
        instance
          .patch(
            projectAPIs.project.asset.buildingGeneral.tenant.tenantApproach(
              this.$route.params.id,
              this.projectData.assetId,
              this.formGeneral.id,
            ),
            {
              tenantApproachId: value,
            },
          )
          .then(response => {
            this.fieldLoader = false
          })
          .catch(err => {
            errorService(err)
            this.fieldLoader = false
            this.$root.$emit('popupUpdation', false, true, null)
          })
      }
    },

    changeWarning(FieldName, value) {
      var that = this
      if (window.previousValue) {
        this.$confirm({
          title: `Are you sure you want to change approach ?`,
          content: h => (
            <div style="color:red;">
              <p>
                This action will effect calculation method and view part of
                tenant.
              </p>
              <p>Please confirm</p>
            </div>
          ),
          onOk() {
            that.updateTenantApproach(FieldName, value)
            const previous = that.dropdownData['tenant_approach'].find(
              i => i.id === window.previousValue,
            ).option
            const current = that.dropdownData['tenant_approach'].find(
              i => i.id === value,
            ).option
            const msg = `Please wait while the tenant approach is changed from ${previous} to ${current}...`
            that.message = msg
            that.$root.$emit('popupUpdation', true, true, msg)
          },
          onCancel() {
            that.formTenants.tenantApproachId = window.previousValue
          },
        })
      } else {
        this.updateTenantApproach(FieldName, value)
        const msg = `Please wait while the tenant approach is selected...`
        this.message = msg
        this.$root.$emit('popupUpdation', true, true, msg)
      }
    },

    updateTenant(fieldName, value, headerName, record, isCheck) {
      if (record.assetId === this.projectData.assetId) {
        const currentValue = !value ? '' : value
        const previousValue = window.previousValue ? window.previousValue : ''
        let isValid = true
        if (previousValue.toString() !== currentValue.toString()) {
          let request = {}
          this.tenantDetails = { ...record }
          switch (fieldName) {
            case 'tenantType':
              const tenantType = this.dropdownData.tenantType.find(
                i => i.tenantType === value,
              )
              request = {
                [fieldName]: !value || value === 'none' ? null : value,
                tenantTypeId: tenantType ? tenantType.id : null,
              }
              break
            case 'tenantSF':
              isValid = validateNumber(value, fieldName, 'Tenant SF')
              if (isValid) {
                request = {
                  [fieldName]: value || null,
                }
              }
              break
            case 'tenantBank':
              request = {
                tenantBankId: null,
                tenantBank: null,
              }
              break
            default:
              request = {
                [fieldName]: value,
              }
              break
          }
          if (isValid) {
            this.updateTenantData(
              record.id,
              request,
              headerName,
              null,
              null,
              value,
              isCheck,
            )
          } else {
            this.gridOptions.api.tabToNextCell()
            const index = this.formTenants.tenants.findIndex(
              i => i.id === record.id,
            )
            setTimeout(() => {
              this.resetRowData(index)
            }, 2000)
          }
        } else {
          if (fieldName === 'tenantSF') {
            isValid = validateNumber(value, fieldName, 'Tenant SF')
            if (!isValid) {
              const index = this.formTenants.tenants.findIndex(
                i => i.id === record.id,
              )
              setTimeout(() => {
                this.resetRowData(index)
              }, 100)
            }
          }
        }
      }
    },

    updateTenantBank(value, bankId, data, index, isCheck) {
      if (data.assetId === this.projectData.assetId) {
        if (index > -1) {
          this.tenantDetails = { ...data }
        }
        var that = this
        const url = projectAPIs.project.asset.buildingGeneral.tenant.apply(
          this.$route.params.id,
          this.projectData.assetId,
          this.formGeneral.id,
          data.id,
          bankId,
        )
        if (data.takeoffCount > 0) {
          this.$confirm({
            title: `Are you sure you want to change tenant bank ?`,
            content: h => (
              <div style="color:red;">
                <p>
                  This action will delete all data related to this tenant:
                  {'  '}
                  {data.tenantName || data.suite}.
                </p>
                <p>Please confirm</p>
              </div>
            ),
            onOk() {
              if (value === 'none') {
                that.updateTenant(
                  'tenantBank',
                  value,
                  'Tenant Bank',
                  data,
                  isCheck,
                )
              } else {
                that.tenantDetails = { ...data }
                const msg = 'Please wait while apply tenant bank!'
                that.$root.$emit('popupUpdation', true, true, msg)
                that.updateTenantData(
                  data.id,
                  bankId,
                  'Tenant Bank',
                  url,
                  'put',
                  null,
                  isCheck,
                )
              }
            },
            onCancel() {
              const tenants = [...that.formTenants.tenants]
              if (that.formTenants.tenantApproachId === 1) {
                tenants[index]['tenantBank'] = data.tenantBank
                tenants[index]['tenantBankId'] = data.tenantBankId
                that.formTenants.tenants = [...tenants]
                setTimeout(() => {
                  that.resetRowData(index)
                }, 1000)
              } else {
                that.formTenants.tenantBankId = data.tenantBankId
              }
            },
          })
        } else {
          if (value === 'none') {
            this.updateTenant(
              'tenantBank',
              value,
              'Tenant Bank',
              data,
              isCheck,
            )
          } else {
            const msg = 'Please wait while apply tenant bank!'
            this.$root.$emit('popupUpdation', true, true, msg)
            this.updateTenantData(
              data.id,
              bankId,
              'Tenant Bank',
              url,
              'put',
              null,
              isCheck,
            )
          }
        }
      }
    },

    updateTenantData(
      id,
      request,
      headerName,
      apiURL,
      apiMethod,
      value,
      isCheck,
    ) {
      var bankId = null
      if (headerName === 'Tenant Bank' && value !== 'none') {
        bankId = request
        request = null
      }
      this.tenantLoader = true
      const method = apiMethod || 'patch'
      let url =
        apiURL ||
        projectAPIs.project.asset.buildingGeneral.tenant.update(
          this.$route.params.id,
          this.projectData.assetId,
          this.formGeneral.id,
          id,
        )
      if (this.projectData.analysisTypeId === 2) {
        url = projectAPIs.project.asset.newConstbuildingGeneral.tenant.update(
          this.$route.params.id,
          this.projectData.assetId,
          this.formGeneral.id,
          id,
        )
      }
      let index = this.formTenants.tenants.findIndex(i => i.id === id)
      instance[method](url, request)
        .then(response => {
          if (this.sortData) {
            this.formTenants.tenants = _.orderBy(
              this.formTenants.tenants,
              [this.sortData.colId],
              [this.sortData.sort],
            )
          }
          index = this.formTenants.tenants.findIndex(i => i.id === id)
          const data = this.formTenants.tenants
          this.tenantLoader = false
          this.isEdit = false
          if (this.projectData.analysisTypeId === 1) {
            let key
            switch (headerName) {
              case 'Suite':
                key = 'suite'
                break
              case 'Tenant Name':
                key = 'tenantName'
                break
              case 'Tenant Type':
                key = 'tenantType'
                const takeoffCount = data[index].takeoffCount
                data[index] = _.get(response.data, 'result', null)
                if (!request.tenantTypeId) {
                  data[index].tenantTypeId = null
                  data[index].tenantType = null
                }
                data[index].takeoffCount = takeoffCount
                data[index].assetId = this.projectData.assetId
                this.formTenants.tenants = data
                const itemsToUpdate = updateGridRecord(
                  this.gridOptions,
                  this.formTenants.tenants[index],
                  data[index],
                )
                this.gridOptions.api.applyTransaction({
                  update: itemsToUpdate,
                })
                this.gridOptions.api.redrawRows()
                break
              case 'Tenant SF':
                key = 'tenantSF'
                if (!isCheck) {
                  this.formTenants.tenantSF = data.reduce((total, item) => {
                    return total + (item.tenantSF || 0)
                  }, 0)
                }
                break
              case 'Tenant Bank':
                this.tenantId = id
                key = 'tenantBank'
                this.showBank = this.formTenants.tenantApproachId === 2
                const tenant = this.dropdownData.tenantBank.find(
                  t => t.id === bankId,
                )
                const itemsToUpdateTenant = []
                this.gridOptions.api.forEachNodeAfterFilterAndSort(function(
                  rowNode,
                ) {
                  if (rowNode.data.id === id) {
                    rowNode.data.tenantSF = rowNode.data.tenantSF
                      ? rowNode.data.tenantSF
                      : tenant.tenantSF
                    rowNode.data.tenantTypeId = rowNode.data.tenantTypeId
                      ? rowNode.data.tenantTypeId
                      : tenant.tenantTypeId
                    rowNode.data.tenantType = rowNode.data.tenantType
                      ? rowNode.data.tenantType
                      : tenant.tenantType
                    rowNode.data.tenantBankId = tenant
                      ? tenant.id
                      : rowNode.data.tenantBankId
                    rowNode.data.tenantBank = tenant
                      ? tenant.tenantName
                      : rowNode.data.tenantBank
                    rowNode.data.takeoffCount =
                      value === 'none' ? 0 : rowNode.data.takeoffCount
                    const data = rowNode.data
                    itemsToUpdateTenant.push(data)
                  }
                })
                this.gridOptions.api.applyTransaction({
                  update: itemsToUpdateTenant,
                })
                this.gridOptions.api.redrawRows()
                break
              default:
                break
            }
            if (!isCheck && index < data.length - 1) {
              this.setFocusedCell(key, index)
            }
          }
        })
        .catch(err => {
          errorService(err)
          this.tenantLoader = false
          this.resetRowData(index)
        })
    },

    updateBulkTenant(selectedRowData) {
      this.loading = true
      let url = projectAPIs.project.asset.buildingGeneral.tenant.bulkUpdate(
        this.$route.params.id,
        this.projectData.assetId,
        this.formGeneral.id,
      )
      if (this.projectData.analysisTypeId === 2) {
        url = projectAPIs.project.asset.newConstbuildingGeneral.tenant.bulkUpdate(
          this.$route.params.id,
          this.projectData.assetId,
          this.formGeneral.id,
        )
      }
      instance
        .put(url, selectedRowData)
        .then(response => {
          this.loading = false
          this.importClicked = false
          this.tenantLoader = true
          this.loadImport = false
          this.getTenants(this.tableParams)
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    applyTenantBank(value) {
      const tenant = this.dropdownData.tenantBank.find(
        i => i.tenantName === value,
      )
      this.updateTenantBank(
        value || 'none',
        tenant ? tenant.id : null,
        {
          id: this.formTenants.tenantId,
          assetId: this.projectData.assetId,
          tenantBankId: this.formTenants.tenantBankId,
          takeoffCount: this.formTenants.takeoffCount,
        },
        undefined,
        true,
      )
      this.formTenants.tenantBankId = tenant ? tenant.id : null
    },

    onChangeTenantType(value) {
      const tenantType = this.dropdownData.tenantType.find(
        i => i.tenantType === value,
      )
      if (tenantType) {
        this.tenantBanks = this.dropdownData.tenantBank.filter(
          i => i.tenantTypeId === tenantType.id,
        )
      } else {
        this.tenantBanks = []
        this.tenantBanks = this.dropdownData.tenantBank
      }
      this.updateTenant(
        'tenantType',
        value || 'none',
        'Tenant Type',
        {
          id: this.formTenants.tenantId,
          assetId: this.projectData.assetId,
        },
        true,
      )
    },

    saveAsBank(data) {
      this.bankName = `${data.tenantName} - Copy`
      this.bankId = data.id
      this.visible = true
      this.apiURL = projectAPIs.project.asset.buildingGeneral.tenant.saveAs(
        this.$route.params.id,
        this.projectData.assetId,
        this.formGeneral.id,
        data.id,
      )
    },

    closeBank(flag) {
      this.visible = flag
    },

    reorder(request) {
      let url = projectAPIs.project.asset.buildingGeneral.tenant.reorder(
        this.$route.params.id,
        this.projectData.assetId,
        this.formGeneral.id,
      )
      if (this.projectData.analysisTypeId === 2) {
        url = projectAPIs.project.asset.newConstbuildingGeneral.tenant.reorder(
          this.$route.params.id,
          this.projectData.assetId,
          this.formGeneral.id,
        )
      }
      instance
        .patch(url, request)
        .then(response => {
          this.tenantLoader = false
          this.selectedRowKeys = []
          this.gridOptions.api.deselectAll()
          this.getTenants()
        })
        .catch(err => {
          this.tenantLoader = false
          errorService(err)
        })
    },

    updateTenantSF() {
      this.updateTenant(
        'tenantSF',
        this.formTenants.tenantSF,
        'Tenant SF',
        {
          id: this.formTenants.tenantId,
          assetId: this.projectData.assetId,
        },
        true,
      )
    },
    // Tenant Details Section End //

    // Grid Methods Section Start //
    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedTenantApproachId = selectedNodes.map(
        node => node.data.tenantApproachId,
      )
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedTenantApproachId = selectedNodes.map(
        node => node.data.tenantApproachId,
      )
    },

    onModelUpdated() {
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length === 0
      ) {
        this.gridOptions.api.showNoRowsOverlay()
      }
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length > 0
      ) {
        this.gridOptions.api.hideOverlay()
      }
    },

    onRowDragEnd(e) {
      this.tenantLoader = true
      const request = []
      this.gridOptions.api.forEachNodeAfterFilterAndSort(function(
        rowNode,
        index,
      ) {
        request.push({
          id: rowNode.data.id,
          sequence: index + 1,
          suite: rowNode.data.suite,
        })
      })
      this.reorder(request)
    },

    onRowDragLeave(e) {
      this.onRowDragEnd(e)
    },
    // Grid Methods Section End //

    // Import/Export Section Start //
    downloadTemplate() {
      this.exportClicked = true
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    beforeUpload(file) {
      const isValid = checkFiles(file.type)
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.getTenants(this.gridOptions)
      }
    },

    clickedCancel() {
      this.exportClicked = false
    },

    updateTable() {
      this.importClicked = false
      this.tenantLoader = true
      this.getTenants(this.tableParams)
    },
    // Import/Export Section End //

    // Common Method Start //
    getWindowSize() {
      this.getColumnSettings(this.gridOptions)
    },

    isNumber(evt) {
      const splitNumber = this.newTenants
      if (splitNumber && splitNumber.length > 3) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    resetRowData(index) {
      const newData = [...this.formTenants.tenants]
      newData[index] = this.tenantDetails
      this.formTenants.tenants = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        this.tenantDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({ update: itemsToUpdate })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(
          focusedCell.rowIndex,
          focusedCell.column.colId,
        )
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: focusedCell.column.colId,
        })
      }
      this.tenantDetails = null
    },

    setFocusedCell(key, index) {
      let newKey
      switch (key) {
        case 'suite':
          newKey = 'tenantName'
          break
        case 'tenantName':
          if (this.projectData.analysisTypeId === 2) {
            newKey = 'tenantSF'
          } else {
            newKey = 'tenantType'
          }
          break
        case 'tenantType':
          newKey = 'tenantSF'
          break
        case 'tenantSF':
          if (this.projectData.analysisTypeId === 2) {
            if (index < this.formTenants.tenants.length - 1) {
              newKey = 'suite'
              index = index + 1
            }
          } else {
            newKey = 'tenantBank'
          }
          break
        case 'tenantBank':
          if (index < this.formTenants.tenants.length - 1) {
            index = index + 1
            newKey = 'suite'
          }
          break

        default:
          break
      }
      if (newKey) {
        this.gridOptions.api.setFocusedCell(index, newKey)
        this.gridOptions.api.startEditingCell({
          rowIndex: index,
          colKey: newKey,
        })
      }
    },
    // Common Method End //

    // Socket Section Start //
    recievedMessage(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.CloneTenant) {
        this.$root.$emit('cloneSuccess', message)
      }
      if (data.EventType === socketEvents.projectSidebarUpdated) {
        if (this.fieldName === 'tenantApproachId') {
          this.$root.$emit('projectSideBarUpdated', message, true)
          this.$root.$emit('popupUpdation', true, true, this.message)
        } else {
          this.$root.$emit('projectSideBarUpdated', message)
        }
      } else if (data.EventType === socketEvents.tenantApproachUpdated) {
        this.tenantLoader = true

        if (this.projectData.structureProfileId === 3) {
          this.showBank = this.formTenants.tenantApproachId === 2
          this.getTenants(this.tableParams)
        }
        this.loadingTenant = 2
        this.fieldName = undefined
        this.message = undefined
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.buildingGeneralUpdated) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.projectTenantBankAdded) {
        this.$root.$emit('popupUpdation', false, true, null)
        if (this.tenantId) {
          const itemsToUpdateTenant = []
          const id = this.tenantId
          this.gridOptions.api.forEachNodeAfterFilterAndSort(function(rowNode) {
            if (rowNode.data.id === id) {
              rowNode.data.takeoffCount = data.Result ? data.Result : 0
              const rowData = rowNode.data
              itemsToUpdateTenant.push(rowData)
            }
          })
          this.gridOptions.api.applyTransaction({
            update: itemsToUpdateTenant,
          })
          this.gridOptions.api.redrawRows()
          this.tenantId = undefined
        }
      } else if (data.EventType === socketEvents.projectTenantAdded) {
        this.bankName = undefined
        this.bankId = undefined
        this.visible = false
      } else if (data.EventType === socketEvents.cloneProjectBuildingGeneral) {
        this.componentKey++
        this.$root.$emit('popupUpdation', false, true, null)
        this.loader = true
        this.getBuildingGeneral()
      } else if (checkEvents(data.EventType)) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.error) {
        this.loadingTenant = 2
        this.$root.$emit('popupUpdation', false, true, null)
        showNotification('error', 'Socket', data.Result)
      }
    },
    // Socket Section End //

    cloneTenant(data) {
      if (data.assetId === this.projectData.assetId) {
        const ids =
          this.selectedRowKeys.length > 0 ? this.selectedRowKeys : [data.id]
        const tenant = {
          tenanatIds: ids,
          asset: this.projectData,
          formTenants: this.formTenants,
          isTenantClone: true,
          formGeneral: this.formGeneral,
          tenantApproachId: this.formTenants.tenantApproachId,
          url: projectAPIs.project.asset.newConstbuildingGeneral.tenant.cloneTenant(
            this.$route.params.id,
            this.projectData.assetId,
            this.formGeneral.id,
          ),
        }
        this.$emit('cloneTenant', tenant)
      }
    },

    getColumnSettings(params) {
      if (params && params.api && params !== 1) {
        params.api.setColumnDefs(this.columnDefs)
      }
      const name =
        this.projectData.analysisTypeId === 2
          ? tableName.project.newConstTenant
          : tableName.project.tenant
      const columnDetails = this.columnSettings.find(
        i => i.screenId === 2 && i.tableName === name,
      )
      if (columnDetails && columnDetails.columnDetails) {
        const tableState = JSON.parse(columnDetails.columnDetails)
        const column = {
          colId: 'display',
          width: 36,
          hide: false,
          pinned: 'left',
          sort: null,
          sortIndex: null,
          aggFunc: null,
          rowGroup: false,
          rowGroupIndex: null,
          pivot: false,
          pivotIndex: null,
          flex: null,
        }
        const isPresent = tableState.some(i => i.colId === 'display')
        if (!isPresent) {
          tableState.unshift(column)
        }
        if (params.columnApi) {
          params.columnApi.applyColumnState({
            state: tableState,
            applyOrder: true,
          })
        }
      } else {
        if (params && params.api) {
          params.api.sizeColumnsToFit()
          this.tableParams = null
          this.tableParams = params
          this.defaultSortedBy = 'tenantName'
          this.defaultSortOrder = true
        }
      }
      if (this.isArchive && this.gridOptions.columnApi) {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'display',
              hide: this.isArchive,
            },
            {
              colId: 'checkbox',
              hide: this.isArchive,
            },
            {
              colId: 'action',
              hide: this.isArchive,
            },
          ],
        })
        if (params) {
          params.api.sizeColumnsToFit()
          this.tableParams = null
          this.tableParams = params
          this.defaultSortedBy = 'tenantName'
          this.defaultSortOrder = true
        }
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const name =
        this.projectData.analysisTypeId === 2
          ? tableName.project.newConstTenant
          : tableName.project.tenant
      const request = {
        screenId: 2,
        tableName: name,
        columnDetails: JSON.stringify(tableState),
      }
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      if (sortData.length > 0) {
        this.formTenants.tenants = _.orderBy(
          this.formTenants.tenants,
          [sortData[0]['colId']],
          [sortData[0]['sort']],
        )
        this.sortData = sortData[0]
      } else {
        this.formTenants.tenants = _.orderBy(
          this.formTenants.tenants,
          ['tenantName'],
          ['asc'],
        )
        this.sortData = {
          colId: 'tenantName',
          sort: 'asc',
        }
      }
      this.updateColumnSetting()
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSetting()
      }
    },
    parseCurrency(value) {
      return value.replace(/\$\s?|(,*)/g, '')
    },
  },
}
